/** Détection des hôtes Burok servis par ce landing. */

export function getHostname(): string {
  if (typeof window === 'undefined') return '';
  return window.location.hostname.toLowerCase();
}

/** Liens courts app (même table `short_links`). */
export function isShortLinkHostname(hostname?: string): boolean {
  const h = (hostname ?? getHostname()).toLowerCase();
  return h === 'burok.shop' || h === 'www.burok.shop' || h === 'link.burok.app';
}

/** Hôte canonique des deeplinks app (hors paiement). */
export function isAppDeeplinkHostname(hostname?: string): boolean {
  const h = (hostname ?? getHostname()).toLowerCase();
  return h === 'app.burok.app' || h === 'www.app.burok.app';
}

/**
 * Premiers segments = routes d'app (pas des shortcodes).
 * Aligné sur TestingBUROKAPP `deeplinkRegistry.ts`.
 */
export const KNOWN_APP_ROUTE_SEGMENTS: ReadonlySet<string> = new Set([
  'app',
  'messages',
  'friend',
  'ami',
  'miniapp',
  'promo',
  'new-app',
  'apppromopage',
  'kiosk',
  'boutique',
  'boutiques',
  'restaurant',
  'restaurants',
  'pay',
  'settings',
  'settingspages',
  'openconnect',
  'oauth',
]);

export function isKnownAppRoutePath(pathname: string): boolean {
  const first = pathname.split('/').filter(Boolean)[0]?.toLowerCase() ?? '';
  return first !== '' && KNOWN_APP_ROUTE_SEGMENTS.has(first);
}
